"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isId = exports.generateId = void 0;
const uuid_1 = require("uuid");
const generateId = () => (0, uuid_1.v4)();
exports.generateId = generateId;
const isId = (id) => (0, uuid_1.validate)(id);
exports.isId = isId;
